export const DEFAULT_INTERVAL = 5 * 1000;
const MAX_INTERVAL = 60 * 10 * 1000;
const noop = () => {};

const states = {
  RUNNING: 'running',
  STOPPED: 'stopped',
};

export const getNextInterval = (fromTime, defaultInterval = DEFAULT_INTERVAL, maxInterval = MAX_INTERVAL) => {
  const diff = Date.now() - fromTime;

  let interval = maxInterval;

  if (diff < 5 * 60 * 1000) {
    interval = (Math.floor(diff / 1000 / 15) + 1) * defaultInterval;
  } else if (diff < 10 * 60 * 1000) {
    interval = Math.floor(diff / 1000 / 60) * 60 * 1000;
  }

  return Math.min(interval, maxInterval);
};

class Poller {
  constructor(opts) {
    this.task = opts.task || noop;
    this.status = states.STOPPED;
    this._startTime = null;
    this.lastPollTime = 0;
    this._maxInterval = MAX_INTERVAL;
    this._defaultInterval = opts.defaultInterval || DEFAULT_INTERVAL;
    this._skipFirstPoll = opts.skipFirstPoll || false;
  }

  poll() {
    const task = () => {
      if (this.status !== states.STOPPED) {
        const now = Date.now();
        const millisSinceLastPoll = this.lastPollTime ? now - this.lastPollTime : 0;
        this.lastPollTime = now;

        if (this._skipFirstPoll) {
          this._skipFirstPoll = false;
        } else {
          this.task(millisSinceLastPoll);
        }

        this._currentTimeout = setTimeout(
          () => task(),
          getNextInterval(this._startTime, this._defaultInterval, this._maxInterval),
        );
      }
    };

    this._currentTimeout = setTimeout(() => {
      task();
    }, 0);
  }

  start() {
    this.status = states.RUNNING;
    this._startTime = Date.now();
    this.poll();
  }

  stop() {
    this.state = states.STOPPED;
    this._startTime = null;
    if (this._currentTimeout) {
      clearTimeout(this._currentTimeout);
    }
  }

  restart() {
    this.stop();
    this.start();
  }

  setMaxInterval(interval = MAX_INTERVAL) {
    this._maxInterval = interval;
  }
}

export default Poller;
